import { useMemo } from 'react';
import { playSound, Sound } from '~/assets/sounds';
import { Divider } from '~/components/ui/Divider';
import { Text } from '~/components/ui/Text';
import { useWalletIcon } from '~/hooks';
import { rage, useInputAction } from '~/rage';
import {
	IModalStateVehicleTestDrive,
	InputAction,
	ModalButtonColor,
	WalletType,
	walletTypeCurrency,
} from '~/shared';
import { CurrencyIcon } from '../../CurrencyIcon';
import { ModalButton } from '../ModalButton';
import {
	StyledButtonsContainer,
	StyledClockIcon,
	StyledModalBody,
	StyledPrice,
	StyledRow,
	StyledTime,
} from './ModalVehicleTestDrive.styled';

const secondsToMinutes = (time?: number) => {
	if (!time) {
		return `0 сек.`;
	}

	const minutes = Math.floor(time / 60);
	const seconds = time % 60;

	if (!minutes) {
		return `${seconds} сек.`;
	}

	if (!seconds) {
		return `${minutes} мин.`;
	}

	return `${minutes} мин. ${seconds} сек.`;
};

const ModalVehicleTestDrive: React.FC<{
	state: IModalStateVehicleTestDrive;
}> = ({ state }) => {
	const currencyIcon = useWalletIcon(walletTypeCurrency[state?.wallet], true);

	const isDonate = useMemo(
		() => state?.wallet === WalletType.Donate,
		[state?.wallet],
	);

	useInputAction(InputAction.CommonMenuAccept, () => {
		rage.modal.replyToCurrentModal({
			isAccepted: true,
		});
	});

	useInputAction(InputAction.CommonMenuClose, () => {
		rage.modal.replyToCurrentModal({
			isAccepted: false,
		});
	});

	return (
		<StyledModalBody>
			<Text style={{ fontSize: 16, color: '#ffffff', opacity: 0.75 }}>
				Вы действительно хотите взять на тест-драйв {state?.vehicleName}?
			</Text>
			<Divider $direction={'H'} style={{ opacity: 0.1 }} />
			<StyledRow>
				<Text style={{ fontSize: 18, color: '#ffffff', opacity: 0.25 }}>
					Время тест-драйва
				</Text>
				<StyledTime>
					<Text style={{ color: '#FFBF42' }}>
						{secondsToMinutes(state?.durationSec)}
					</Text>
					<StyledClockIcon />
				</StyledTime>
			</StyledRow>
			<Divider $direction={'H'} style={{ opacity: 0.1 }} />
			<StyledRow>
				<Text style={{ fontSize: 18, color: '#ffffff', opacity: 0.25 }}>
					Стоимость аренды
				</Text>
				<StyledPrice>
					<Text>{state?.price?.toLocaleString('ru-RU')}</Text>
					<CurrencyIcon
						icon={currencyIcon}
						size={'md'}
						style={{ opacity: isDonate ? 1 : 0.5, marginTop: -2 }}
					/>
				</StyledPrice>
			</StyledRow>
			<StyledButtonsContainer>
				<ModalButton
					$type={ModalButtonColor.Secondary}
					onClick={() => {
						rage.modal.replyToCurrentModal({ isAccepted: false });
						playSound(Sound.ClickButton);
					}}
					onMouseEnter={() => playSound(Sound.LinkCursor)}
				>
					Отменить
				</ModalButton>
				<ModalButton
					$type={ModalButtonColor.Success}
					onClick={() => {
						rage.modal.replyToCurrentModal({ isAccepted: true });
						playSound(Sound.ClickButton);
					}}
					onMouseEnter={() => playSound(Sound.LinkCursor)}
				>
					Оплатить аренду
				</ModalButton>
			</StyledButtonsContainer>
		</StyledModalBody>
	);
};

export { ModalVehicleTestDrive };
